<template>
  <modal
    :step="step"
    :has-close-button="canClose"
    :close-on-background-click="canClose"
    :modifiers="['rounded-border']"
    @close="close"
    class="delete-account-modal"
  >
    <template v-slot:form>
      <delete-account-form />
    </template>
    <template v-slot:success>
      <delete-account-success />
    </template>
  </modal>
</template>

<script>
import { mapState } from "vuex"
import Modal from "@/shared/modal"
import DeleteAccountForm from "./form"
import DeleteAccountSuccess from "./success"

export default {
  name: "DeleteAccountModal",
  components: {
    Modal,
    DeleteAccountForm,
    DeleteAccountSuccess
  },
  computed: {
    ...mapState({
      step: (state) => state.settings.deleteAccount.currentStep
    }),
    canClose() {
      return this.step !== "success"
    }
  },
  methods: {
    close() {
      this.$store.dispatch("settings/closeDeleteAccount")
    }
  }
}
</script>
